export const worldMapData = [
  {
    id: 'usa',
    name: 'United States',
    path: 'M 170 120 L 280 120 L 300 150 L 280 180 L 220 190 L 180 170 Z',
    color: '#3B82F6'
  },
  {
    id: 'uk',
    name: 'United Kingdom',
    path: 'M 445 115 L 455 110 L 460 120 L 450 125 L 445 120 Z',
    color: '#2563EB'
  },
  {
    id: 'canada',
    name: 'Canada',
    path: 'M 170 80 L 280 80 L 300 110 L 280 120 L 170 120 Z',
    color: '#60A5FA'
  },
  {
    id: 'australia',
    name: 'Australia',
    path: 'M 700 300 L 780 320 L 800 380 L 720 400 L 680 360 Z',
    color: '#1D4ED8'
  },
  {
    id: 'newzealand',
    name: 'New Zealand',
    path: 'M 790 370 L 810 365 L 815 380 L 795 385 Z',
    color: '#3B82F6'
  },
  {
    id: 'india',
    name: 'India',
    path: 'M 650 200 L 690 190 L 700 230 L 670 250 L 640 230 Z',
    color: '#2563EB'
  },
  {
    id: 'uae',
    name: 'United Arab Emirates',
    path: 'M 590 190 L 610 185 L 615 205 L 595 210 Z',
    color: '#60A5FA'
  },
  // New European Countries
  {
    id: 'france',
    name: 'France',
    path: 'M 460 140 L 470 135 L 475 145 L 465 150 Z',
    color: '#3B82F6'
  },
  {
    id: 'germany',
    name: 'Germany',
    path: 'M 480 130 L 490 125 L 495 135 L 485 140 Z',
    color: '#2563EB'
  },
  {
    id: 'italy',
    name: 'Italy',
    path: 'M 490 160 L 500 155 L 505 165 L 495 170 Z',
    color: '#60A5FA'
  },
  {
    id: 'spain',
    name: 'Spain',
    path: 'M 440 170 L 450 165 L 455 175 L 445 180 Z',
    color: '#1D4ED8'
  },
  // Central Asian Countries
  {
    id: 'uzbekistan',
    name: 'Uzbekistan',
    path: 'M 620 160 L 630 155 L 635 165 L 625 170 Z',
    color: '#3B82F6'
  },
  // South Asian Countries
  {
    id: 'nepal',
    name: 'Nepal',
    path: 'M 670 200 L 680 195 L 685 205 L 675 210 Z',
    color: '#2563EB'
  },
  {
    id: 'bangladesh',
    name: 'Bangladesh',
    path: 'M 690 210 L 700 205 L 705 215 L 695 220 Z',
    color: '#60A5FA'
  },
  // Background continents with lower opacity
  {
    id: 'europe',
    name: 'Europe',
    path: 'M 450 120 L 520 100 L 540 130 L 500 160 L 460 150 Z',
    color: '#1E40AF20'
  },
  {
    id: 'asia',
    name: 'Asia',
    path: 'M 550 120 L 750 140 L 780 200 L 700 280 L 600 260 L 540 180 Z',
    color: '#1E40AF20'
  },
  {
    id: 'africa',
    name: 'Africa',
    path: 'M 450 180 L 520 200 L 540 280 L 480 320 L 440 280 L 430 220 Z',
    color: '#1E40AF20'
  }
];